import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPenilikPegawai from 'app/KinerjaPenilikPegawaiPage/components/PageGuardPenilikPegawai'
import PageGuardPelaksanaan from 'app/KinerjaPenilikPegawaiPage/components/PageGuardPelaksanaan'
import PelaksanaanTugasPage from 'app/KinerjaPenilikPegawaiPage/pages/Pelaksanaan/PelaksanaanTugas'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-penilik-pegawai-enabled'] || false
    const enabledPelaksanaan =
      toggle?.['kinerja-penilik-pegawai-pelaksanaan-enabled'] || false

    if (!enabled || !enabledPelaksanaan) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => {
  return (
    <PageGuardPenilikPegawai>
      <PageGuardPelaksanaan>
        <PelaksanaanTugasPage />
      </PageGuardPelaksanaan>
    </PageGuardPenilikPegawai>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengelolaan Kinerja',
}

export default Page
